import { render } from "./ListaUser.vue?vue&type=template&id=714f92c0"
import script from "./ListaUser.vue?vue&type=script&lang=js"
export * from "./ListaUser.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__